export const columns = [
  {
    field: "name",
    headerName: "Name",
    minWidth: 200,
    required: true,
    editable: true,
    flex: 1,
  },
  {
    field: "vm_sku",
    headerName: "SKU",
    minWidth: 200,
    required: true,
    editable: true,
    flex: 1,
  },
  {
    field: "vm_region",
    headerName: "Region",
    minWidth: 200,
    required: true,
    editable: true,
    flex: 1,
  },
  {
    field: "preferred",
    headerName: "Preferred",
    minWidth: 200,
    editable: true,
    required: true,
    type: "boolean",
    nullable: false,
    default: false,
    flex: 1,
  }
];

export class NewEntry {
  name = "";
}
